// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"80":"datasetQuery","718":"datasetEdit"}[chunkId] + "." + {"80":"1b063a32","718":"2e48400c"}[chunkId] + ".css";
};